import {
  GroupResourceModel,
  GroupResourceModelAttributes,
  GroupResourceCollection,
} from 'src/models/GroupResourceModel';
import {
  GroupResourceAdapterInteface,
  ListGroupResourcesInput as BaseListGroupResourcesInput,
} from 'src/adapter/GroupResourceAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export type ListGroupResourcesInput = BaseListGroupResourcesInput;
export class GroupResourceApiClass {
  adapter: GroupResourceAdapterInteface;
  constructor(adapter: GroupResourceAdapterInteface) {
    this.adapter = adapter;
  }
  async listGroupResources(
    conditions: ListGroupResourcesInput
  ): Promise<{ total: number; data: GroupResourceCollection }> {
    try {
      const res = await this.adapter.listGroupResources(conditions);
      return {
        total: res.total,
        data: res.data.map(
          (groupResource: GroupResourceModelAttributes) =>
            new GroupResourceModel(groupResource)
        ),
      };
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
